import { FormControl } from '@angular/forms';
import { ApplianceDetailsFormField } from './appliance-details-form-field.enum';

export interface ApplianceDetailsForm {
  [ApplianceDetailsFormField.ApplianceCode]: FormControl<string | null>;
  [ApplianceDetailsFormField.BrandCode]: FormControl<string | null>;
  [ApplianceDetailsFormField.ModelNumber]: FormControl<string | null>;
  [ApplianceDetailsFormField.PartsWarranty]: FormControl<number | null>;
  [ApplianceDetailsFormField.PurchaseDate]: FormControl<Date | null>;
  [ApplianceDetailsFormField.PurchasePrice]: FormControl<number | null>;
  [ApplianceDetailsFormField.Retailer]: FormControl<string | null>;
  [ApplianceDetailsFormField.SerialNumber]: FormControl<string | null>;
  [ApplianceDetailsFormField.Warranty]: FormControl<number | null>;
}
